var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccessibilityPictoservicios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#001689"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3152 3.69248C12.2968 4.10313 12.1416 4.49425 11.8763 4.79846C11.611 5.10268 11.2523 5.30096 10.8618 5.35915L10.9668 8.99289L14.3727 8.99895V10.6916H11.0897L11.137 11.549H15.8625L18.006 16.8759L19.5953 16.2518L20 17.7284L16.9813 18.8802L14.5233 13.143H9.47882L9.07239 3.69873C9.07129 3.47632 9.11232 3.25587 9.19313 3.05003C9.27394 2.84418 9.39293 2.65698 9.54329 2.49917C9.69364 2.34135 9.87241 2.21602 10.0693 2.13037C10.2663 2.04471 10.4775 2.00041 10.6908 2C10.9042 1.9996 11.1156 2.0431 11.3128 2.12801C11.51 2.21292 11.6892 2.33757 11.8401 2.49481C11.9911 2.65205 12.1107 2.8388 12.1922 3.04434C12.2737 3.24988 12.3155 3.47016 12.3152 3.69258V3.69248ZM14.9353 15.3618L15.9675 17.4996C15.5215 18.5491 14.7907 19.4397 13.8651 20.0617C12.9395 20.6836 11.8596 21.0097 10.7584 20.9998C10.0022 20.9998 9.25338 20.8445 8.55473 20.5429C7.85608 20.2413 7.22127 19.7992 6.68655 19.2418C6.15183 18.6845 5.72767 18.0228 5.43829 17.2946C5.14891 16.5664 4.99998 15.7859 5 14.9977C5.00476 13.7856 5.35777 12.6027 6.0135 11.6017C6.66924 10.6006 7.59763 9.82725 8.67899 9.38129L8.64212 11.2957C8.059 11.658 7.57048 12.1644 7.21973 12.7702C6.86897 13.376 6.66678 14.0625 6.63102 14.7691C6.59527 15.4757 6.72704 16.1806 7.01471 16.8215C7.30237 17.4624 7.73707 18.0195 8.28038 18.4437C8.82369 18.868 9.45889 19.1462 10.1298 19.2537C10.8008 19.3613 11.4868 19.295 12.1274 19.0606C12.7679 18.8262 13.3432 18.431 13.8023 17.9098C14.2615 17.3887 14.5904 16.7577 14.7601 16.0726L14.9353 15.3618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessibilityPictoservicios);
export default __webpack_public_path__ + "static/media/Ic_Accessibility-Pictoservicios.79ac3b00b6787a86e39f91101b9f5243.svg";
export { ForwardRef as ReactComponent };